/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import React, {useCallback, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import 'react-tabs/style/react-tabs.css'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {StyledCard} from '../../../../components/StyledCard'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  filterSelector,
  resetFilterPlantAssignment,
  setFilterPlantAssignment,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {setIsLoading} from '../../../../redux/slices/sipSlices'
import {fetcherPlantAssignment, headers} from '../../../../services/fetcher'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {RowFilter} from './RowFilter'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'

type Props = {
  className: string
}

const TablePlantA: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterPlantAssignment} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 7,
    onReloadTable: () => dispatch(resetFilterPlantAssignment()),
  })

  const [plantA, setPlantA] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [numberURL, setNumberURL] = useState([])

  const onFetchPlantAssignment = useCallback(() => {
    setLoading(true)
    setIsError(false)

    fetcherPlantAssignment(filterPlantAssignment)
      .then((res) => {
        const data = res.data.data
        setPlantA(data.data)
        setPage(data.current_page)
        setPer(data.per_page)
        setNumberURL(data.links)
        setLoading(false)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterPlantAssignment])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterPlantAssignment({...filterPlantAssignment, per_page: value ?? 5}))
  }

  const handleReloadTable = () => {
    dispatch(resetFilterPlantAssignment())
    onFetchPlantAssignment()
  }

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setIsLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filterPlantAssignment)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setPlantA(data.data)
      setPage(data.current_page)
      setPer(data.per_page)
      setNumberURL(data.links)
      setIsLoading(false)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const getData = setTimeout(onFetchPlantAssignment, 1000)
    return () => clearTimeout(getData)
  }, [onFetchPlantAssignment])

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Sales Org Code')}</th>
              <th>{t('Plant')}</th>
              <th>{t('Distribution Channel')}</th>
              <th>{t('Sales Org Desc')}</th>
              <th>{t('DC Description')}</th>
              <th>{t('Plant Desc')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : plantA.length === 0 ? (
              <RowEmptyData />
            ) : (
              plantA.map((plants, _index) => (
                <tr key={_index}>
                  <td>{_index + 1 + (page * per - per)}</td>
                  <td>{plants.sales_org_code}</td>
                  <td>{plants.plant}</td>
                  <td>{plants.distribution_channel}</td>
                  <td>{plants.sales_org_desc}</td>
                  <td>{plants.dc_description}</td>
                  <td>{plants.plant_desc}</td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {TablePlantA}
